import React from "react";

import "./errorBox.css";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";

export interface ErrorBoxProps {
    statusCode?: number;
    isLoggedOut: boolean;
    buttonLabel?: string;
    onClickAction: () => void;
}

export const ErrorBox = ({
    statusCode,
    isLoggedOut,
    buttonLabel,
    onClickAction
}: ErrorBoxProps) => {
    const { t } = useTranslation("common");

    const getReportTitle = () => {
        if (statusCode === 400) {
            return `${t("errorPage.badRequest")}`;
        }
        if (statusCode === 401) {
            return `${t("errorPage.unauthorised")}`;
        }
        if (statusCode === 403) {
            return `${t("errorPage.forbidden")}`;
        }
        if (statusCode === 404) {
            return `${t("errorPage.notFound")}`;
        }
        if (statusCode === 500) {
            return `${t("errorPage.serverError")}`;
        }
        return `${t("errorPage.error")}`;
    };

    const getReportDescription = () => {
        if (statusCode === 400) {
            return `${t("errorPage.badRequestDescription")}`;
        }
        if (statusCode === 401) {
            return `${t("errorPage.unauthorisedDescription")}`;
        }
        if (statusCode === 403) {
            return `${t("errorPage.forbiddenDescription")}`;
        }
        if (statusCode === 404) {
            return `${t("errorPage.notFoundDescription")}`;
        }
        if (statusCode === 500) {
            return `${t("errorPage.serverErrorDescription")}`;
        }
        return `${t("errorPage.error")}`;
    };

    function getButtonLabel() {
        if (statusCode === 401 || isLoggedOut) {
            return `${t("errorPage.goToSignIn")}`;
        }

        return buttonLabel;
    }

    return (
        <div className="error-box" data-testid="idwal-error">
            <div className="flex flex-column">
                <p className="error-box__code">{statusCode}</p>
                <p className="error-box__title">{getReportTitle()}</p>
                <p className="error-box__description">
                    {getReportDescription()}
                </p>
                <Button
                    label={getButtonLabel()}
                    onClick={onClickAction}
                    className="error-box__button"
                />
            </div>
        </div>
    );
};
